import { Note } from "../../../../models/Note";
import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

const _mergeAuthorData = (oldNotes: Note[], newNotes: [], defaultAuthorName?: string): Note[] => {
  return newNotes.map((newNote: Note) => {
    const oldNote = oldNotes.find((note) => note.id === newNote.id);
    return {
      ...newNote,
      author_name: oldNote?.author_name || defaultAuthorName || "",
    };
  });
};

export const createNote = (
  userId: number,
  authorName: string,
  language: string,
  setUserData: Function,
  setActiveNote: Function,
  setIsEditing: Function
) => {
  ApiService.post(`users/${userId}/notes`, {
    value: "",
  })
    .then((resp) => {
      setUserData((previous_user_data: any) => {
        const updatedNotes = _mergeAuthorData(previous_user_data.user_notes || [], resp.data.notes, authorName);
        setActiveNote(updatedNotes?.sort((a, b) => b.dt_created - a.dt_created)?.[0]);
        setIsEditing(true);
        return {
          ...previous_user_data,
          user_notes: updatedNotes,
        };
      });
    })
    .catch((error) => {
      if (error.status === 400) {
        alert(translate(language, "COMPONENTS.USER.ERROR_NOTE_TOO_BIG"));
        console.error(error);
      } else {
        alert(translate(language, "COMPONENTS.USER.ERROR"));
        console.error(error);
      }
    });
};

export const deleteNote = (userId: number, noteId: string, setUserData: Function, callback?: Function) => {
  ApiService.delete(`users/${userId}/notes/${noteId}`)
    .then((resp) => {
      setUserData((previous_user_data: any) => {
        const updatedNotes = _mergeAuthorData(previous_user_data.user_notes || [], resp.data.notes);
        return {
          ...previous_user_data,
          user_notes: updatedNotes,
        };
      });
      callback?.();
    })
    .catch((err) => {
      alert("An error occurred on deleting note, more details in console. Contact Developer Team");
      console.error(err);
    });
};

export const updateNote = (
  userId: number,
  language: string,
  note: Note,
  setUserData: Function,
  callback?: Function
) => {
  const body = {} as any;

  if (note.value) {
    body.value = note.value;
  }
  if (note.title) {
    body.title = note.title;
  }

  ApiService.put(`users/${userId}/notes/${note.id}`, body)
    .then((resp) => {
      setUserData((prev: any) => {
        const updatedNotes = _mergeAuthorData(prev.user_notes || [], resp.data.notes);
        callback?.(updatedNotes.find((updatedNote) => updatedNote.id === note.id));
        return {
          ...prev,
          user_notes: updatedNotes,
        };
      });
    })
    .catch((error) => {
      if (error.status === 400) {
        alert(translate(language, "COMPONENTS.USER.ERROR_NOTE_TOO_BIG"));
        console.error(error);
      } else {
        alert(translate(language, "COMPONENTS.USER.ERROR"));
        console.error(error);
      }
    });
};

export const togglePinNote = (userId: number, note: Note, setUserData: Function, callback?: Function) => {
  (!note.is_pinned
    ? ApiService.delete(`users/${userId}/notes/${note.id}/pin`)
    : ApiService.post(`users/${userId}/notes/${note.id}/pin`, {})
  )
    .then((resp) => {
      setUserData((prev: any) => {
        const updatedNotes = _mergeAuthorData(prev.user_notes || [], resp.data.notes);
        callback?.(updatedNotes.find((updatedNote) => updatedNote.id === note.id));
        return {
          ...prev,
          user_notes: updatedNotes,
        };
      });
    })
    .catch((err) => {
      alert("An error occurred on pinning/unpinning note, more details in console. Contact Developer Team");
      console.error(err);
    });
};
